type InstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

let pendingPrompt: InstallPromptEvent | null = null;

export function captureInstallPrompt() {
  const onPrompt = (event: Event) => {
    event.preventDefault();
    pendingPrompt = event as InstallPromptEvent;
  };
  const onInstalled = () => { pendingPrompt = null; };
  window.addEventListener('beforeinstallprompt', onPrompt);
  window.addEventListener('appinstalled', onInstalled);
  return () => { window.removeEventListener('beforeinstallprompt', onPrompt); window.removeEventListener('appinstalled', onInstalled); };
}

export async function installFromBrowserPrompt() {
  if (!pendingPrompt) return 'unavailable' as const;
  const prompt = pendingPrompt;
  pendingPrompt = null;
  await prompt.prompt();
  const result = await prompt.userChoice;
  return result.outcome;
}
